import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { MSTR } from '../models/mstr';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class MSTRHttpService {
  private mstrPostUrl: string = this.environment.baseUrl + '/api/mstr';
  private mstrRedirectPostUrl: string = this.environment.baseUrl + '/api/mstr/redirect';
  private mstrCallPostUrl: string = this.environment.baseUrl + '/api/mstr/call';
  private mstrGetHtml: string = this.environment.baseUrl + '/api/mstr/getHtml';


  constructor(private http: AppAuthHttpService,
              private http2: HttpClient,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  private get jsonOptions(): RequestOptions {
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({headers: headers});
    return options;
  }


  getLink(): Observable<MSTR> {
    return this.http.post(`${this.mstrPostUrl}`, this.jsonOptions)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/mstr.http.service.ts